export { createClient, HttpClient } from './core/client'
export { HttpError } from './core/errors'
export { createAuthInterceptor } from './interceptors/auth'
export type { AuthInterceptorConfig } from './interceptors/auth'
export { QueryClient, QueryClientProvider, HydrationBoundary } from '@tanstack/react-query'
export type { DehydratedState } from '@tanstack/react-query'
export { useHttpQuery } from './react/use-http-query'
export { useHttpMutation } from './react/use-http-mutation'
export { DEFAULT_CLIENT_RETRY } from './constants'
export type {
  Interceptor,
  InterceptorContext,
  InterceptorFn,
  HttpClientConfig,
  HttpRequest,
  HttpResponse,
  RequestOptions,
  CreateClientOptions,
  RetryConfig,
  RetryOption,
  Hooks,
} from './types'
